import { render } from "./NewMessageAbsenceInfo.vue?vue&type=template&id=72d75b51&scoped=true"
import script from "./NewMessageAbsenceInfo.vue?vue&type=script&lang=js"
export * from "./NewMessageAbsenceInfo.vue?vue&type=script&lang=js"

import "./NewMessageAbsenceInfo.vue?vue&type=style&index=0&id=72d75b51&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d75b51"]])

export default __exports__